import * as yup from 'yup';

export const commonCreateGeneralProposalValidation: { [x: string]: any; } = {
    tariffType: yup.string().required("Missing."),
    tariffCode: yup.string().required("Missing."),
    currencyCode: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
};

export const commonCreateGeneralProposalItemTierValidation: { [x: string]: any; } = {
    forevery: yup.number().required("Missing."),
    cycle: yup.number().required("Missing."),
    uom: yup.string().required("Missing."),
    rate: yup.number().required("Missing."),
    minimum: yup.number().required("Missing."),
};
export const createGeneralProposalValidation: { [x: string]: any; } = {
    ...commonCreateGeneralProposalValidation,
};
export const createGeneralProposalItemTierValidation: { [x: string]: any; } = {
    ...commonCreateGeneralProposalItemTierValidation,
};

export const createGeneralProposalValidationSchema = yup.object().shape(createGeneralProposalValidation);
export const createGeneralProposalItemTierValidationSchema = yup.object().shape(createGeneralProposalItemTierValidation);

